import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setLogout } from "state";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const user = useSelector((s) => s.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("menu-open", mobileOpen);
    return () => document.body.classList.remove("menu-open");
  }, [mobileOpen]);

  const closeMenu = () => setMobileOpen(false);

  const handleLogout = () => {
    dispatch(setLogout());
    closeMenu();
    navigate("/");
  };

  return (
    <>
      <nav className={scrolled ? "scrolled" : undefined}>
        <Link to="/" className="nav-logo" aria-label="MediConsult Group" onClick={closeMenu}>
          <span className="nav-logo-mark">DH</span>
          <span className="nav-logo-name">
            <strong>Dr. Hoffmann</strong>
            <span>MediConsult Group</span>
          </span>
        </Link>
        <ul className="nav-links">
          <li><NavLink to="/">Home</NavLink></li>
          <li><a href="/#konzept">Konzept</a></li>
          <li><a href="/#lizenz">Lizenzmodell</a></li>
          <li><a href="/#tarife">Tarife</a></li>
          <li><a href="/#kontakt">Kontakt</a></li>
          {user ? (
            <>
              <li><NavLink to="/konto">Mein Konto</NavLink></li>
              <li>
                <button type="button" onClick={handleLogout}>Abmelden</button>
              </li>
            </>
          ) : (
            <li><NavLink to="/einloggen">Login</NavLink></li>
          )}
          <li><Link to="/buchen" className="nav-cta">Jetzt Termin buchen</Link></li>
        </ul>
        <div
          className={`hamburger ${mobileOpen ? "active" : ""}`}
          role="button"
          aria-label="Menü öffnen"
          aria-expanded={mobileOpen}
          tabIndex={0}
          onClick={() => setMobileOpen((v) => !v)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setMobileOpen((v) => !v);
            }
          }}
        >
          <span></span><span></span><span></span>
        </div>
      </nav>

      <div className={`mobile-menu ${mobileOpen ? "open" : ""}`}>
        <Link to="/" onClick={closeMenu}>Home</Link>
        <a href="/#konzept" onClick={closeMenu}>Konzept</a>
        <a href="/#lizenz" onClick={closeMenu}>Lizenzmodell</a>
        <a href="/#tarife" onClick={closeMenu}>Tarife</a>
        <a href="/#kontakt" onClick={closeMenu}>Kontakt</a>
        {user ? (
          <>
            <Link to="/konto" onClick={closeMenu}>Mein Konto</Link>
            <button type="button" onClick={handleLogout}>Abmelden</button>
          </>
        ) : (
          <Link to="/einloggen" onClick={closeMenu}>Login</Link>
        )}
        <Link to="/buchen" onClick={closeMenu} className="btn-primary">
          Jetzt Termin buchen
        </Link>
      </div>
    </>
  );
};

export default Navbar;
